import store from '@/store';

let loginParams = {
    AuthUrl: '',
    CallBackUrl: '',
    AccessTokenUrl: '',
    clientID: '',
    clientSecret: '',
    scope: '',
};
let registParams = {
    Url: '',
    fromUrl: '',
};
let logoutParams = {
    Url: '',
    CallBackUrl: '',
};
if (process.env.VUE_APP_CURRENTMODE == 'production') {
    loginParams = {
        AuthUrl: 'https://login.uniontech.com/oauth2/authorize',
        CallBackUrl: 'https://edu.uniontech.com/callback',
        AccessTokenUrl: 'https://login.uniontech.com/api/oauth2/token',
        clientID: 'db3bc54332d07815374a05389669381f4408d32c',
        clientSecret: '14ea02e753d7315c1a6a9f46a254466e364f8da6',
        scope: 'base,user:read,user:contact:read',
    };
    registParams = {
        Url: 'https://account.chinauos.com/register',
        fromUrl: 'https://edu.uniontech.com/',
    };
    logoutParams = {
        Url: 'https://login.uniontech.com/logout',
        CallBackUrl: 'https://edu.uniontech.com/',
    };
} else if (process.env.VUE_APP_CURRENTMODE == 'prev') {
    loginParams = {
        AuthUrl: 'https://login-pre.uniontech.com/oauth2/authorize',
        CallBackUrl: 'https://precollege.uniontech.com/callback',
        AccessTokenUrl: 'https://login-pre.uniontech.com/api/oauth2/token',
        clientID: '4de59202e11c11eaaf1d02420ade1b19',
        clientSecret: '4de5921fe11c11eaaf1d02420ade1b19',
        scope: 'base,user:read,user:contact:read',
    };
    registParams = {
        Url: 'https://account-pre.uniontech.com/register',
        fromUrl: 'https://precollege.uniontech.com/',
    };
    logoutParams = {
        Url: 'https://login-pre.uniontech.com/logout',
        CallBackUrl: 'https://precollege.uniontech.com/',
    };
    // //////////////////////dev-pre////////////////////////////////
} else if (process.env.VUE_APP_CURRENTMODE == 'test') {
    loginParams = {
        AuthUrl: 'http://login-pre.uniontech.com/oauth2/authorize',
        CallBackUrl: 'http://college-dev.uniontech.com/callback',
        // CallBackUrl:"http://10.30.36.106:8888/college/app/callback",
        AccessTokenUrl: 'http://login-pre.uniontech.com/api/oauth2/token',
        clientID: '4de59202e11c11eaaf1d02420ade1b19',
        clientSecret: '4de5921fe11c11eaaf1d02420ade1b19',
        scope: 'base,user:read,user:contact:read',
    };
    registParams = {
        Url: 'http://account-pre.uniontech.com/register',
        fromUrl: 'http://college-dev.uniontech.com/',
        // fromUrl:"http://10.30.36.106:8888/college/"
    };
    logoutParams = {
        Url: 'http://login-pre.uniontech.com/logout',
        CallBackUrl: 'http://college-dev.uniontech.com/',
        // CallBackUrl:"http://10.30.36.106:8888/college/",
    };
} else {
    loginParams = {
        AuthUrl: 'http://login-pre.uniontech.com/oauth2/authorize',
        CallBackUrl: 'http://college-dev.uniontech.com/callback',
        // CallBackUrl: 'http://10.10.9.130:1024/callback',
        AccessTokenUrl: 'http://login-pre.uniontech.com/api/oauth2/token',
        clientID: '4de59202e11c11eaaf1d02420ade1b19',
        clientSecret: '4de5921fe11c11eaaf1d02420ade1b19',
        scope: 'base,user:read,user:contact:read',
        // AuthUrl : "https://login-pre.uniontech.com/oauth2/authorize",
        // CallBackUrl : "https://prepxb.uniontech.com/callback",
        // AccessTokenUrl : "https://login-pre.uniontech.com/api/oauth2/token",
        // clientID : "4de59202e11c11eaaf1d02420ade1b19",
        // clientSecret : "4de5921fe11c11eaaf1d02420ade1b19",
        // scope : "base,user:read,user:contact:read",
    };
    registParams = {
        Url: 'http://account-pre.uniontech.com/register',
        fromUrl: 'http://college-dev.uniontech.com/',
    };
    logoutParams = {
        Url: 'http://login-pre.uniontech.com/logout',
        CallBackUrl: 'http://college-dev.uniontech.com/',
    };
    // loginParams = {
    //     AuthUrl : "https://login.uniontech.com/oauth2/authorize",
    //     CallBackUrl : "https://college.uniontech.com/callback",
    //     AccessTokenUrl : "https://login.uniontech.com/api/oauth2/token",
    //     clientID : "db3bc54332d07815374a05389669381f4408d32c",
    //     clientSecret : "14ea02e753d7315c1a6a9f46a254466e364f8da6",
    //     scope : "base,user:read,user:contact:read",
    // }
    // registParams = {
    //     Url:"https://account.chinauos.com/register",
    //     fromUrl : "https://college.uniontech.com/"
    // }
    // logoutParams = {
    //     Url:"https://login.uniontech.com/logout",
    //     CallBackUrl:"https://college.uniontech.com/"
    // }
}

export { loginParams, registParams, logoutParams };
